import React, { Component } from "react";
import * as PropTypes from "prop-types";
import { Col, Form, Input, InputNumber, message, Modal, Row, Select, Switch, Tabs } from "antd";

import { anamneseService } from "./../../redux/services";

import {
	UIDrawerForm,
	UILabelHelp,
} from "./../../components";

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

class Create extends Component {
	static propTypes = {
		visible   : PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose   : PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			isLoading: true,
			isSending: false,
			nextOrder: 1,
			type     : null,
		};
	}

	onOpen = () => {
		this.setState({
			isLoading: true,
		});

		anamneseService.getAdditionalInformation()
		.then((response) => {
			this.setState({
				isLoading: false,
				nextOrder: response.data.next_order,
			});
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
				onOk   : () => {
					// Force close
					return this.onClose();
				}
			});
		});
	};

	resetFields = () => {
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	onFinish = (values) => {
		this.setState({
			isSending: true,
		});

		const data = {...values};

		anamneseService.create(data)
		.then((response) => {
			this.setState({
				isSending: false,
			});

			// Reset fields
			this.resetFields();

			// Success message
			message.success("Registro cadastrado com sucesso.");

			// Callback
			this.props.onComplete();
		})
		.catch((data) => {
			this.setState({
				isSending: false,
			});

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	render() {
		const {visible} = this.props;

		const {isLoading, isSending, nextOrder, type} = this.state;

		return (
			<UIDrawerForm
				visible={visible}
				width={500}
				onClose={this.onClose}
				isLoading={isLoading}
				isSending={isSending}
				formId={formId}
				title="Inserir novo registro">
				<Form
					ref={el => this.form = el}
					id={formId}
					layout="vertical"
					scrollToFirstError
					onFinish={this.onFinish}
					initialValues={{
						order    : nextOrder,
						required : true,
						is_active: true,
					}}>
					<Tabs defaultActiveKey="general">
						<Tabs.TabPane forceRender tab="Info. Gerais" key="general">
							<Form.Item name="name" label="Nome" hasFeedback rules={[{required: true, message: "Campo obrigatório."}]}>
								<Input maxLength={191} />
							</Form.Item>
							<Form.Item name="type" label="Tipo de campo" hasFeedback rules={[{required: true, message: "Campo obrigatório."}]}>
								<Select
									optionFilterProp="children"
									filterOption={(input, option) => (typeof option.children === 'string' ? option.children : option.children.props.children).toLowerCase().indexOf(input.toLowerCase()) >= 0}
									allowClear
									placeholder="Selecione o tipo"
									showSearch
									onChange={(value) => this.setState({type: value})}>
									<Select.Option value="select">Escolha única</Select.Option>
									<Select.Option value="select_multiple">Múltipla escolha</Select.Option>
									<Select.Option value="text">Texto livre</Select.Option>
								</Select>
							</Form.Item>
							{(type === 'select' || type === 'select_multiple') && (
								<Form.Item name="values" label={<UILabelHelp title="Opções" content="Coloque uma opção por linha." />}>
									<Input.TextArea autoSize={{minRows: 3}} />
								</Form.Item>
							)}
							<Form.Item name="order" label="Ordem" hasFeedback rules={[{required: true, message: "Campo obrigatório."}]}>
								<InputNumber min={0} style={{width: '100%', maxWidth: 150}} />
							</Form.Item>
							<Row gutter={16}>
								<Col xs={24} sm={12}>
									<Form.Item name="required" label="Obrigatório" valuePropName="checked">
										<Switch />
									</Form.Item>
								</Col>
								<Col xs={24} sm={12}>
									<Form.Item name="is_active" label="Ativo" valuePropName="checked">
										<Switch />
									</Form.Item>
								</Col>
							</Row>
						</Tabs.TabPane>
					</Tabs>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Create;
